let itCertPage = document.querySelector("#MainContent.certificazioni");

if (itCertPage) {
    let links = document.querySelectorAll(".certificazioni .menu-certification a");

    links.forEach((el, i) => {
        if (i > 2) return;
        el.textContent = i == 0 ? 'Certificazioni Caschi da moto' : (i == 1 ? 'Lenti' : 'Caschi da moto');
    });

    let firstTitle = document.querySelector(".certificazioni .section-template--25093059969370__rich_text_RgaJNH-padding h2");
    if (firstTitle) {
        firstTitle.textContent = 'Certificazioni Caschi da moto';
    }

    let secondTitle = document.querySelector(".certificazioni .section-template--25093059969370__rich_text_GLWmpe-padding h2");
    if (secondTitle) {
        secondTitle.textContent = 'Caschi da moto';
    }

    let thirdTitle = document.querySelector(".certificazioni .section-template--25093059969370__rich_text_4QT4jk-padding h2");
    if (thirdTitle) {
        thirdTitle.textContent = 'Lenti';
    }

    let urlsLentiToChange = [
        {
            name : "JUST1 NERVE GOGGLE",
            url : "https://cdn.shopify.com/s/files/1/0965/2112/6220/files/JUST1_NERVE_GOGGLE_ITA.jpg?v=1771577038"
        },
        {
            name : "JUST1 SNIPER",
            url : "https://cdn.shopify.com/s/files/1/0965/2112/6220/files/JUST1_SNIPER_ITA.jpg?v=1771577048"
        },
        {
            name : "JUST1 SWING GOGGLE",
            url : "https://cdn.shopify.com/s/files/1/0965/2112/6220/files/JUST1_SWING_GOGGLE_ITA.jpg?v=1771577048"
        }
    ];
    let linksLenti = document.querySelectorAll(".certificazioni .section-template--25093059969370__rich_text_4QT4jk-padding .rich-text__text ul li a");
    linksLenti.forEach(el => {
        for(let i = 0; i < urlsLentiToChange.length; i++) {
            if(urlsLentiToChange[i].name != el.textContent) { continue; }
            el.href = urlsLentiToChange[i].url;
            el.title = urlsLentiToChange[i].url;
            break;
        }
    });
}